import React, { useState } from 'react';
import { Carousel } from 'antd';
import PropTypes from 'prop-types';

const AuthLayout = (WraperContent) => {
  return function () {

    const contentData = [
      {
        image: '../../../static/img/defaultImages/Leads.png',
        title: 'Stay on top of every lead',
        subtitle: 'Track, prioritize, and convert-without missing a beat',
        imageAlt: "Leads",
      },
      {
        image: '../../../static/img/defaultImages/Automation.png',
        title: 'Automate tasks. Close deals faster',
        subtitle: 'Let workflows handle the busywork so your team can focus on selling',
        imageAlt: "Automation",
      },
      {
        image: '../../../static/img/defaultImages/Forecast.png',
        title: 'Smarter sales decisions, backed by data',
        subtitle: 'Real-time analytics and forecasting to help you hit every target',
        imageAlt: "Forecast",
      },
      {
        image: '../../../static/img/defaultImages/Revenue.png',
        title: 'More revenue. Stronger connections',
        subtitle: 'Deliver smarter support with AI and win more deals',
        imageAlt: "Revenue",
      },
    ];
    const Slide = ({ item }) => {
      const [imageLoaded, setImageLoaded] = useState(false);

      const handleImageLoad = () => {
        setImageLoaded(true);
      };

      return (
        <div className="carousel-slide" style={{ textAlign: 'center' }}>
          <img
            src={require(`../../../static/img/defaultImages/${item.imageAlt}.png`)}
            alt={item.imageAlt}
            className="carousel-img"
            onLoad={handleImageLoad}
          />
          <div
            style={{
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 0.8s ease-in-out',
            }}
          >
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
          </div>
        </div>
      );
    };

    Slide.propTypes = {
      item: PropTypes.shape({
        imageAlt: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
      }).isRequired,
    };
    return (
      <>
        <div className="login-wrappern">
          <header className="login-header">
            <img className="logo"
              src={require('../../../static/img/Logo/Logo.png')}
              alt="Multivrse Logo"
            />
          </header>
          <div className="login-main">
            <div className="login-form-section">
              <WraperContent />
            </div>
            <div className="login-image">
              <div className='carousel-section'>
                <Carousel autoplay>
                  {contentData.map((item, index) => (
                    <Slide key={index} item={item} />
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
};

export default AuthLayout;
